import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getComment, submitApi } from '@src/services/api';
import { formatComment, isNative, gotoNewPage } from '@src/utils/index';
import { Grounds } from '@ifeng-fe/client_grounds';
import auth from '@ifeng-fe/ui_pc_auth';
import { throttle } from '@ifeng-fe/ui_base';
import useLogin from '@src/hook/useLogin';

const Layout = ({ content, setShow, setToastContent }) => {
    const {
        ucmsId,
        docData: { title, skey },
        link,
    } = content;
    const [list, setList] = useState([]);
    const [value, setValue] = useState('');
    const { otherLogin } = useLogin();
    const init = async () => {
        try {
            const data = await getComment(ucmsId, skey);

            if (data?.comments && data?.comments.length) {
                const commentsList = data.comments.filter((item) => item.comment_contents);

                setList(commentsList.splice(0, 5));
            }
        } catch (error) {
            alert(error.message);
        }
    };

    useEffect(() => {
        init();
    }, []);

    const submitData = async () => {
        if (value.trim()) {
            try {
                await submitApi({ content: value, docUrl: ucmsId, docName: title, link, skey });
            } catch (error) {
                console.log(error);
            }

            setToastContent('发布成功，审核通过后展示');
            setShow(true);
            setValue('');
        } else {
            setToastContent('请先输入内容');
            setShow(true);
        }
    };

    const submit = () => {
        if (isNative()) {
            if (Grounds.userIsLogin()) {
                // 提交评论
                if (Grounds.getUserInfo()?.getPhoneNum()) {
                    // 绑定手机号了
                    submitData();
                } else {
                    window.grounds.userBind();
                }
            } else {
                Grounds.userLogin();
            }
        } else if (auth.isLogin() && auth.isReal()) {
            // 提交评论
            submitData();
        } else {
            otherLogin();
        }
    };

    const change = (e) => {
        setValue(e.target.value);
    };

    return (
        <div className={styles.layout}>
            <div className={styles.bg} />
            <div className={styles.middle} />
            <div className={styles.bottom} />
            <div className={styles.header}>
                <div className={styles.category} />
                <div className={styles.more} onClick={gotoNewPage({ type: 'web', url: `https://gentie.ifeng.com/c/comment/${ucmsId}` })}>
                    {'查看全部>'}
                </div>
            </div>
            <div className={styles.commentBox}>
                {list.map((item, index) => {
                    return (
                        <div className={styles.item} key={index}>
                            <span className={styles.nickname}>{item.uname}</span>
                            <span className={styles.maohao}>:</span>
                            <span dangerouslySetInnerHTML={{ __html: formatComment(item.comment_contents) }} />
                        </div>
                    );
                })}
            </div>
            <div className={styles.box}>
                <div className={styles.replayBox}>
                    <input className={styles.input} placeholder="欢迎大家写下自己的留言" onChange={throttle(change)} value={value} />
                    <div className={styles.btn} onClick={submit}>
                        发布
                    </div>
                </div>
            </div>
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
    setShow: PropTypes.func,
    setToastContent: PropTypes.func,
};

export default errorBoundary(Layout);
